export const t = { "en": { "placeholder": "Placeholder" } };
export const d = [require("UIComponents/lang/en.lyaml"),require("property-management-common/lang/en.lyaml"),require("smart-property-fill-lib/lang/en.lyaml")];